<template>
  <div class="report-container">
    <div class="report-header">
      <img src="./img.png" alt="Ingersoll Rand Logo" ref="logo" class="logo">
      <div class="report-title">
        <h1>Ingersoll Rand Year 2025 PC Report</h1>
      </div>
    </div>
    <img src="./img3.png" ref="coverImage" class="cover-image">
    <div class="report-title">
      <h1>智慧工业, 精准赋能</h1>
      <p>通过精准而全面的数据采集、萃取和提炼，洞察机组过去，现在和未来的运行指数，实现不同业务端口多样需求的理想解决方案</p>
    </div>

    <div class="report-content" :class="{fontinfo:isExport}">
      <table class="info-table">
        <tbody>
        <tr>
          <td class="info-item">
            <span>客户名称</span>
            <p>{{ healthReportProp.deviceBasicInfo.customerName|| 'N/A' }}</p>
          </td>
          <td class="info-item">
            <span>服务管理单位</span>
            <p>{{ healthReportProp.deviceBasicInfo.customerRegion|| 'N/A' }}</p>
          </td>
          <td class="info-item">
            <span>合同编号</span>
            <p>{{ healthReportProp.deviceBasicInfo.contractName|| 'N/A' }}</p>
          </td>
        </tr>
        <tr>
          <td class="info-item">
            <span>资产名称</span>
            <p>{{ healthReportProp.deviceBasicInfo.modelDesc|| 'N/A' }}</p>
          </td>
          <td class="info-item">
            <span>服务工程师</span>
            <p>{{ healthReportProp.deviceBasicInfo.responsibleEngineerName || 'N/A'}}</p>
          </td>
          <td class="info-item">
            <span>合同类型</span>
            <p>{{ healthReportProp.deviceBasicInfo.serviceType || 'N/A'}}</p>
          </td>
        </tr>
        <tr>
          <td class="info-item">
            <span>序列号</span>
            <p>{{ healthReportProp.dsn || "N/A" }}</p>
          </td>
          <td class="info-item">
            <span>服务合同有效期</span>
            <p>{{ healthReportProp.deviceBasicInfo.contractStartDate || 'N/A'}}-{{ healthReportProp.deviceBasicInfo.contractEndDate || 'N/A'}}</p>
          </td>
          <td class="info-item">
            <span>数据源时段</span>
            <p>{{ healthReportProp.deviceBasicInfo.startTime || 'N/A'}}-{{ healthReportProp.deviceBasicInfo.endTime || 'N/A'}}</p>
          </td>
        </tr>
        <tr>
          <td class="info-item">
            <span>安装日期</span>
            <p>{{ healthReportProp.deviceBasicInfo.installDate || 'N/A'}}</p>
          </td>
          <td class="info-item">
            <span>发运日期</span>
            <p>{{ healthReportProp.deviceBasicInfo.deliveryDate || 'N/A'}}</p>
          </td>
          <td class="info-item">
            <span>是否安装了IoT</span>
            <p>Yes</p>
          </td>
        </tr>
        <tr>
    <td class="info-item" v-bind:style="{ padding: '10px', borderRadius: '4px' }">
      <span>健康状态:</span>
   
        <p v-bind:style="{ color: 'green' || '#f5f5f5' }">{{ healthReportProp.healthStatus.status || 'N/A' }}</p>
        

    </td>
    <td class="info-item" v-bind:style="{ padding: '10px', borderRadius: '4px' }">
      <span>利用率状态:</span>
      <p v-bind:style="{ color: 'green' || '#f5f5f5' }">中度利用率</p>
    </td>
  </tr>
        </tbody>
      </table>

      <h2 v-if="this.reportConfig.cycleType == 'month'">本月核心数据({{ reportConfig.cycleDate || 'N/A'}}):</h2>
      <table class="info-table">
        <tbody>
  <tr v-if="reportConfig.statInfoEnabled === 'true'">
    <td class="info-item">
      <span>运行小时:</span>
      <p>{{ healthReportProp.cycleCoreData.calcRunningHour }}</p>
    </td>
    <td class="info-item">
      <span>加载小时:</span>
      <p>{{ healthReportProp.cycleCoreData.calcLoadedHour }}</p>
    </td>
    <td class="info-item">
      <span>加载率:</span>
      <p>{{ healthReportProp.cycleCoreData.loadRate || 0 }}%</p>
    </td>
    <td class="info-item">
      <span>利用率:</span>
      <p>{{ healthReportProp.cycleCoreData.rate || 0 }}%</p>
    </td>
  </tr>
  <tr v-if="reportConfig.alertInfoEnabled === 'true'">
    <td class="info-item">
      <span>Trip数:</span>
      <p>{{ healthReportProp.cycleCoreData.tripInfo && healthReportProp.cycleCoreData.tripInfo.length }}</p>
    </td>
    <td class="info-item">
      <span>Warning数:</span>
      <p>{{ healthReportProp.cycleCoreData.warningInfo && healthReportProp.cycleCoreData.warningInfo.length }}</p>
    </td>
  </tr>
</tbody>
      </table>

      
      <div v-if="healthReportProp.cycleCoreData.tripInfo != null && reportConfig.alertInfoEnabled === 'true'" style="width:100%">
            <span>Top 3 Trip:</span>
            <table class="top-3-trip">
              <thead>
              <tr>
                <th>设备号</th>
                <th>网关号</th>
                <th>报警类型</th>
                <th >报警码</th>
                <th >报警内容</th>
                <th >报警数</th>
              </tr>
              </thead>
              <tbody v-if="healthReportProp.cycleCoreData.top3TripInfo != null && healthReportProp.cycleCoreData.top3TripInfo.length > 0" >
              <tr v-for="item in healthReportProp.cycleCoreData.top3TripInfo">
                <td >{{ item.Dsn }}</td>
                <td >{{ item.Gsn }}</td>
                <td >{{ item.AlarmType }}</td>
                <td >{{ item.AlarmCode }}</td>
                <td >{{ item.AlarmContent }}</td>
                <td >{{ item.AlarmCount }}</td>
              </tr>
 
              </tbody>
              <tbody v-else>
                <tr style="height: 40px;">
                  <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
              </tr>
              <tr style="height: 40px;">
                  <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
              </tr>
              <tr style="height: 40px;">
                  <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td ></td>
              </tr>
              </tbody>
            </table>
          </div>

      <h2>截止当前核心数据({{ reportConfig.cycleDate || 'N/A'}}):</h2>
      <!-- 截止当前核心数据 -->
<table class="info-table">
  <tr>
    <td class="info-item">
      <span>运行小时:</span>
      <p>{{ healthReportProp.lifecycleCoreData.calcRunningHour  }}</p>
    </td>
    <td class="info-item">
      <span>加载小时:</span>
      <p>{{ healthReportProp.lifecycleCoreData.calcLoadedHour || 0 }}</p>
    </td>
    <td class="info-item">
      <span>加载率:</span>
      <p>{{ healthReportProp.lifecycleCoreData.loadRate || 0 }}%</p>
    </td>
    <td class="info-item">
      <span>利用率:</span>
      <p>{{ healthReportProp.lifecycleCoreData.rate || 0 }}%</p>
    </td>
  </tr>
</table>


      <div class="chart-section">
        <div >
          <table class="chart-table" ref="charttable">
            <thead>
            <tr>
              <th colspan="4" style="height: 50px;">运行时间&amp;加卸载比例</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>日期</th>
              <td v-for="item in healthReportProp.deviceRunTimeRateList" style="height: 30px;">{{ item.cycle || '' }}</td>
            </tr>
            <tr>
              <th>累计运行时间</th>
              <td v-for="item in healthReportProp.deviceRunTimeRateList"  style="height: 30px;">{{ item.calcRunningTime ? item.calcRunningTime + ' 小时' : ''}}</td>
            </tr>
            <tr>
              <th rowspan="2" >加卸载比例</th>
              <td v-for="item in healthReportProp.deviceRunTimeRateList" style="height: 30px;">{{ item.loadRate ? item.loadRate + '%' : ''}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="chart-graph">
          <div style="width: 100%; margin-bottom: 10px">
          <div class="combined-threshold">
            阈值：<input type="number" v-model="thresholds.combined" @input="handleNumberInput('combined')" @keydown="(e) => handleKeydown(e)"/>
          </div>
          </div>
          <canvas id="combinedChart" ref="CombinedLine"></canvas>

        </div>

        <div class="chart-graph" v-for="(value, key, index) in deviceMonitor">
          <div style="width: 100%; margin-bottom: 10px">
          <div class="threshold-input">
            阈值：<input type="number" v-model="thresholds[key]" @input="handleNumberInput(key)" @keydown="(e) => handleKeydown(e)"/>
          </div>
          </div>
          <canvas :id="key" :ref="key"></canvas>

        </div>

      </div>
    </div>

    <div v-if="reportConfig.serviceInfoEnabled === 'true'">
      <h2>工单记录</h2>
      <table class="sfa-table" >
        <thead>
        <tr>
          <th>工单编号</th>
          <th>设备型号</th>
          <th>序列号</th>
          <th>客户申诉</th>
          <th>服务时间</th>
          <th>服务内容1</th>
          <th>服务内容2</th>
          <th>核定工时</th>
          <th>工时耗费</th>
          <th>合同控制号</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in sfaList" :key="item.SFID">
          <td>{{ item.name }}</td>
          <td>{{ healthReportProp.deviceBasicInfo.modelDesc }}</td>
          <td>{{ healthReportProp.dsn }}</td>
          <td>{{ item.complainType }}</td>
          <td>{{ item.faultDate }}</td>
          <td>
            {{ item.faultName01 || '' }}
          </td>
          <td>
            {{ item.faultName02 || '' }}
          </td>
          <td>
            {{ item.approvalLaborHour01 || '' }}
          </td>
          <td>
            {{ item.approvalLaborHour01 ? item.approvalLaborHour01 * 540 : '' }}
          </td>
          <td>
            {{ item.serviceContractControlNumber || '' }}
          </td>
        </tr>
        <tr v-if="sfaList.length > 0" style="background-color: #e6f7ff;">
          <td colspan="7"><strong>总计</strong></td>
          <td><strong>{{ sfaSummary.totalLaborHours }}</strong></td>
          <td><strong>{{ sfaSummary.totalApprovedLaborHours.toFixed(2) }}</strong></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="reportConfig.sparePartInfoEnabled === 'true'">
      <h2>备件更换记录</h2>
      <table class="sfa-table" >
        <thead>
        <tr>
          <th>产品编号</th>
          <th>型号</th>
          <th>服务时间</th>
          <th>主类</th>
          <th>数量</th>
          <th>总金额(未税)</th>
          <th>合同控制号</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="product in sfaProducts">
          <td>{{ product.product?.productCode }}</td>
          <td>{{ product.product?.modelCode }}</td>
          <td>{{ product.serviceDate }}</td>
          <td>{{ product.product?.serviceProductPrimaryCategory }}</td>
          <td>{{ product.quantity }}</td>
          <td>{{ product.listPrice }}</td>
          <td>
            {{ product.serviceContractControlNumber || '' }}
          </td>
        </tr>
        <tr v-if="sfaProducts.length > 0" style="background-color: #e6f7ff;">
          <td colspan="4"><strong>总计</strong></td>
          <td><strong>{{ sparePartSummary.totalQuantity }}</strong></td>
          <td><strong>{{ sparePartSummary.totalCost.toFixed(2) }}</strong></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="editor-section">
      <h2>专家建议</h2>
      <textarea ref="inputnotes" v-model="notes" placeholder="在此输入专家建议..." rows="5"></textarea>
    </div>

    <div class="footer">
      <p > <h3 style="text-align:left">状态定义:</h3></p>

    <div class="health-definition footer">
      <p > <h3 style="text-align:left">1. 健康状态定义:</h3></p>
      <div style="display: flex;text-align:left;">
      
      <p style=" margin-right: 20px;"><span style="font-weight: bold;">健康：</span><span>绿色, 一个月Trip小于2 Warning小于4</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">亚健康：</span><span>黄色, 一个月Trip大于等于2小于4 Warning小于8</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">非健康：</span><span>红色, 一个月Trip大于等于4 Warning大于等于8</span></p>

      </div>
      <div style="display: flex;text-align:left;">
        <p style=" margin-right: 20px;"><span style="font-weight: bold;">Notes: </span><span>trip的优先级高于Warning, 如果Trip达到数量直接报告健康状态，如果Trip没有达标则看warning</span></p>
      </div>
      
  </div>

    <div class="load-rate-definition footer">
      <p > <h3 style="text-align:left">2. 利用率状态定义:</h3></p>
      <div style="display: flex; text-align:left;">
        <p style=" margin-right: 20px;"><span style="font-weight: bold;">高利用率：</span><span>75%以上</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">中度利用率：</span><span>35%-75%</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">低利用率：</span>><span>35%以下</span></p>
      </div>
    </div>
  </div>
  <div class="export-button">
      <el-button type="primary" ref="exportButton" @click="exportToWord">报告导出</el-button>
    </div>

  </div>
</template>
<script>
import {
  GetCycleCoreData,
  GetDeviceBasicInfo,
  GetDeviceMetricsMonthlyList,
  GetDeviceMetricsWeeklyList,
  GetDeviceRateList,
  GetDeviceRunTimeRateList,
  GetLifecycleCoreData,
  GetNotes,
  GetPreviousCycleCoreData,
  GetPreviousLifecycleCoreData,
  SaveNotes,
  GetSfaInfoList
} from "@/api/api";
import html2canvas from "html2canvas";

import axios from '../../../utils/http';

export default {
  name: 'healthReport',
  data() {
    return {
      isExport: false,
      dialogVisible: true,
      reportConfig: {
        dialogVisible: false,
        baseInfoEnabled: true,
        statInfoEnabled: true,
        alertInfoEnabled: false,
        energySensorEnabled: false,
        vibrationSensorEnabled: false,
        insightsEnabled: false,
        serviceInfoEnabled: false,
        sparePartInfoEnabled: false,
        externalImportEnabled: false,
        showFileImportDialog: false,
        reportType: "",
        cycleType: "",
        cycle: "",
        cycleDate: "",
        healthReportId: ""
      },
      healthReportProp: {
        dsn: "",
        gsn: "",
        deviceBasicInfo: {},
        deviceUseRateList: [],
        deviceRunTimeRateList: [],
        cycleCoreData: {},
        deviceLoadedRateList: [],
        lifecycleCoreData: {},
        previousCycleCoreData: {},
        previousLifecycleCoreData: {},
        dischargeTemperatureList: [],
        dischargePressureList: [],
        colors: [],
        healthStatus: {}
      },
      sfaList: [],
      sfaProducts: [],
      useRateLineChart: null, // 保存 UseRateLine 的 ECharts 实例
      loadingLineChart: null,
      combinedChart: null,
      dischargeTemperatureChart: null,
      dischargePressureChart: null,
      notes: '',
      deviceMonitorChart: {},
      thresholds: {
      },
      deviceMonitor: {},
      monitormMetrics: {
        "InletVacuum": "进气真空",
        "WetSumpPressure": "分离压力",
        "OutletTemperature": "出口温度",
        "InletTemperature": "进气温度",
        "InjectedCoolantTemperature": "喷油温度",
        "InletPressure": "进气压力",
        "DischargeTemperature": "排气温度",
        "PischargePressure": "排气压力"
      },
      monitorUtil: {
        "InletVacuum": "bar",
        "WetSumpPressure": "bar",
        "OutletTemperature": "℃",
        "InletTemperature": "℃",
        "InjectedCoolantTemperature": "℃",
        "InletPressure": "bar",
        "DischargeTemperature": "℃",
        "PischargePressure": "bar"
      },
      sfaSummary: {
        totalLaborHours: 0,     // 核定工时总和
        totalApprovedLaborHours: 0  // 工时耗费总和
      },
      sparePartSummary: {
        totalQuantity: 0,
        totalCost: 0
      }
    };
  },
  created() {
    this.reportConfig = this.$route.query;
    this.reportConfig.cycleDate = this.getLastDayOfMonth(this.reportConfig.cycle);
    GetNotes(this.reportConfig.healthReportId).then((res) => {
      if (res) {
        this.notes = res.result.notes;
      }
    });

  },
  mounted() {
    let vm = this;
    this.getHealthDetailInfo(vm.reportConfig)
        .then(() => {
          this.renderLine();
        });
    if (this.reportConfig.serviceInfoEnabled) {
      GetSfaInfoList(this.healthReportProp.dsn).then((res) => {
        this.sfaList = res.result;
        this.sfaSummary.totalLaborHours = this.sfaList.reduce((total, item) => {
          const hours = parseFloat(item.approvalLaborHour01) || 0;
          return total + hours;
        }, 0);

        this.sfaSummary.totalApprovedLaborHours = this.sfaList.reduce((total, item) => {
          const hours = parseFloat(item.approvalLaborHour01) || 0;
          return total + hours * 540;
        }, 0);
        if (this.sfaList.length > 0) {
          this.sfaProducts = this.sfaList.flatMap((item) => {
            return item.sfaProducts;
          });
          this.sparePartSummary.totalQuantity = this.sfaProducts.reduce((total, product) => {
            const quantity = parseInt(product.quantity) || 0;
            return total + quantity;
          }, 0);

          this.sparePartSummary.totalCost = this.sfaProducts.reduce((total, product) => {
            const price = parseFloat(product.listPrice) || 0;
            const quantity = parseInt(product.quantity) || 0;
            return total + price * quantity;
          }, 0);
        }
      });
    }
  },
  watch: {
    notes: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.saveNotes();
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    handleKeydown(e) {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
      if (allowedKeys.includes(e.key)) return;
      if (!/^\d+$/.test(e.key) && e.key !== '.') {
        e.preventDefault();
      }
    },
    handleNumberInput(key) {
      const value = this.thresholds[key];
      if (typeof value === 'number') return;
      this.thresholds[key] = value.replace(/[^0-9.]/g, '');
      if(key == 'combined') {
        this.InitCombinedLine(
            this.healthReportProp.deviceUseRateList,
            this.healthReportProp.deviceLoadedRateList
        );
      } else {
        var container = this.$refs[key][0]; // 假设你在模板中添加了一个新的 canvas 元素
        this.deviceMonitorChart[key] = this.renderMetricsEcharts(container, this.deviceMonitor[key], this.monitormMetrics[key], this.monitorUtil[key], key);
      }
    },
    getLastDayOfMonth(dateStr) {
      const [year, month] = dateStr.split('-').map(Number);
      const lastDate = new Date(year, month, 0); // 关键：设置为下个月的第0天
      const pad = (num) => String(num).padStart(2, '0');
      return `${year}-${pad(month)}-${pad(lastDate.getDate())}`;
    },

    async saveNotes() {
      if (!this.notes) {
        console.log('No notes to save');
        return;
      }
      try {
        const response = await SaveNotes(
          this.reportConfig.healthReportId,
          this.notes);
        console.log('Notes saved successfully:', response);
      } catch (error) {
        console.error('Error saving notes:', error);
      }
    },
    renderLine() {
      this.$nextTick(() => {
        this.InitCombinedLine(this.healthReportProp.deviceUseRateList, this.healthReportProp.deviceLoadedRateList);
        this.InitMonitormMetricsLine();
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.closeHealthReport();

    },
    closeHealthReport() {
      this.healthReportProp = {
        dsn: "",
        gsn: "",
        deviceBasicInfo: {},
        deviceUseRateList: [],
        cycleCoreData: {},
        deviceLoadedRateList: [],
        lifecycleCoreData: {}
      };
      this.reportConfig = {};
    },
    async getHealthDetailInfo(row) {
      let that = this;
      this.healthReportProp.dsn = row.dsn;
      this.healthReportProp.gsn = row.gsn;
      this.healthReportProp.deviceUseRateList = await this.deviceUseRateList();
      this.healthReportProp.deviceBasicInfo = await this.deviceBasicInfo();
      this.healthReportProp.deviceLoadedRateList = this.healthReportProp.deviceUseRateList;
      this.healthReportProp.cycleCoreData = await this.cycleCoreData();

      this.healthStatusM();
      this.rateStatus();
      this.healthReportProp.lifecycleCoreData = await this.lifecycleCoreData();
      this.healthReportProp.deviceRunTimeRateList = await this.deviceRunTimeRateList();

      await this.deviceMonitorList();
    },
    healthStatusM() {
      if (this.healthReportProp.cycleCoreData
          && this.healthReportProp.cycleCoreData.warningInfo
          && this.healthReportProp.cycleCoreData.warningInfo.length < 4
          && this.healthReportProp.cycleCoreData.tripInfo
          && this.healthReportProp.cycleCoreData.tripInfo.length < 2) {
        this.healthReportProp.healthStatus = {
          status: '健康',
          color: '#67C23A'
        }
      } else if (this.healthReportProp.cycleCoreData
          && this.healthReportProp.cycleCoreData.warningInfo
          && this.healthReportProp.cycleCoreData.warningInfo.length < 8
          && this.healthReportProp.cycleCoreData.tripInfo
          && this.healthReportProp.cycleCoreData.tripInfo.length < 4) {
        this.healthReportProp.healthStatus = {
          status: '亚健康',
          color: '#E6A23C'
        }
      } else if (this.healthReportProp.cycleCoreData
          && this.healthReportProp.cycleCoreData.warningInfo
          && this.healthReportProp.cycleCoreData.warningInfo.length >= 8
          && this.healthReportProp.cycleCoreData.tripInfo
          && this.healthReportProp.cycleCoreData.tripInfo.length >= 4) {
        this.healthReportProp.healthStatus = {
          status: '不健康',
          color: '#F56C6C'
        }
      } else {
        this.healthReportProp.healthStatus = {
          status: '未知',
          color: '#f5f5f5'
        }
      }
    },
    rateStatus() {
      if (this.healthReportProp.cycleCoreData && this.healthReportProp.cycleCoreData.rate >= 75)  {
        this.healthReportProp.rateStatus = {
          status: '高利用率',
          color: 'green'
        } 
      }else if (this.healthReportProp.cycleCoreData
          && this.healthReportProp.cycleCoreData.rate >= 35) {
        this.healthReportProp.rateStatus = {
          status: '中等利用率',
          color: '#007BFF'
        }
      } else {
        this.healthReportProp.rateStatus = {
          status: '低利用率',
          color: 'red'
        }
      }

    },

    async dischargeTemperatureList() {
      if (this.healthReportProp.dsn) {
        let res2 = null;
        if (this.reportConfig.cycleType === 'week') {
          res2 = await GetDeviceMetricsWeeklyList(this.healthReportProp.dsn, '排气温度');
        } else {
          res2 = await GetDeviceMetricsMonthlyList(this.healthReportProp.dsn, '排气温度');
        }
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async dischargePressureList() {
      if (this.healthReportProp.dsn) {
        let res2 = null;
        if (this.reportConfig.cycleType === 'week') {
          res2 = await GetDeviceMetricsWeeklyList(this.healthReportProp.dsn, '排气压力');
        } else {
          res2 = await GetDeviceMetricsMonthlyList(this.healthReportProp.dsn, '排气压力');
        }
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },

    async deviceMonitorList() {
      for (let key in this.monitormMetrics) {
        let metrics = this.monitormMetrics[key]
        let result = await this.getDeviceMonitormMetrics(metrics);
        if (!result || result.length == 0) {
          continue;
        }
        this.$set(this.deviceMonitor, key, result);
      }
    },

    async getDeviceMonitormMetrics(metrics) {
      if (this.healthReportProp.dsn) {
        let res2 = null;
        if (this.reportConfig.cycleType === 'week') {
          res2 = await GetDeviceMetricsWeeklyList(this.healthReportProp.dsn, metrics, this.reportConfig.cycleDate);
        } else {
          res2 = await GetDeviceMetricsMonthlyList(this.healthReportProp.dsn, metrics, this.reportConfig.cycleDate);
        }
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },

    async deviceBasicInfo() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetDeviceBasicInfo(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType, this.reportConfig.cycleDate);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },
    async deviceUseRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'use', this.reportConfig.cycleType, this.reportConfig.cycleDate);
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async deviceRunTimeRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRunTimeRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, '', this.reportConfig.cycleType, this.reportConfig.cycleDate);
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async cycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetCycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType, this.reportConfig.cycle);
        if (!res2 || !res2.result) {
          return {};
        }
        res2.result.warningInfo = JSON.parse(res2.result.warningInfo || "[]");
        res2.result.tripInfo = JSON.parse(res2.result.tripInfo || "[]");
        let sort = res2.result.tripInfo.sort((a, b) => {
          return b.AlarmCount - a.AlarmCount;
        });
        res2.result.top3TripInfo = sort.slice(0, 3);
        return res2.result;
      }
      return {};
    },
    async previousCycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetPreviousCycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return {};
        }
        res2.result.warningInfo = JSON.parse(res2.result.warningInfo || "[]");
        res2.result.tripInfo = JSON.parse(res2.result.tripInfo || "[]");
        return res2.result;
      }
      return {};
    },
    async deviceLoadedRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'loaded', this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async lifecycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetLifecycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType, this.reportConfig.cycle);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },

    async previousLifecycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetPreviousLifecycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },

    renderCombinedEcharts(container, useRateData, loadingData) {
      var ctx = container.getContext('2d');
      let that = this;
      var customPlugin = {
        // 自定义插件：直接定义 afterDraw 钩子
        id: 'custom-annotation', // 可选：为插件命名
        afterDraw: (chart) => {
          const { options } = chart.config;
          const ctx = chart.canvas.getContext('2d');
          const yValue = options.plugins.customPlugin.value || 50;
          const yPixel = chart.scales.y.getPixelForValue(yValue);

          ctx.save();
          ctx.beginPath();
          ctx.setLineDash([5, 5]); // 设置虚线
          ctx.moveTo(0, yPixel);
          ctx.lineTo(chart.width, yPixel);
          ctx.strokeStyle = "grey";
          ctx.stroke();
          ctx.restore();
        }
      };
      let sclca = 2;
      let formatDecimal = function(value) {
        if (typeof value !== 'number') return value;
        return value % 1 !== 0 ? value.toFixed(sclca) : value.toString();
      };
      let useRate = [];
      let loading = [];
      useRateData.forEach(item => useRate.push({x :item.cycle, y: item.rate}));
      loadingData.forEach(item => loading.push({x :item.cycle, y: item.loadRate}));
      let config = {
        type: 'line',
        data: {
          labels: this.healthReportProp.deviceBasicInfo.last12Months, // 使用 UseRateLine 的时间轴
          datasets: [
            {
              label: this.$t('desc.UseRate'), // UseRateLine 的标签
              data: useRate,
              borderColor: 'red', // UseRateLine 的颜色
              fill: false
            },
            {
              label: this.$t('desc.Loading'), // LoadingLine 的标签
              data: loading,
              borderColor: 'blue', // LoadingLine 的颜色
              fill: false
            }
          ]
        },
        options: {
          interaction: {
            intersect: false,
            mode: 'index',
          },
          plugins: {
            legend: {
              position: 'right', // 将图例位置设置为右侧
            },
            title: {
              display: true,
              text: '利用率和加载率',
              font: {
                size: 20
              }
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  const label = dataset.label || '';
                  const value = tooltipItem.yLabel;
                  return label + ': ' + value;
                }
              }
            },
            customPlugin: {
              color: 'green', // 自定义参数
              value: this.thresholds['combined'] || 0
            }
          },
          scales: {
            y: {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                suggestedMin: 0,
                suggestedMax: 100,
                callback: function (value, index, values) {
                  return formatDecimal(value) + '%';
                }
              }
            }
          }
        }
      };
      const allData = [];
      useRate.forEach(item => allData.push(item.y));
      loading.forEach(item => allData.push(item.y));
      if (allData.length == 0) {
        allData.push(0)
      }
      let maxVal = Math.ceil(Math.max(...allData));
      let minVal = Math.ceil(Math.min(...allData)) - 1;
      if (this.thresholds['combined'] !== undefined && this.thresholds['combined'] > maxVal) {
        maxVal = Number(this.thresholds['combined']);
      }
      if (this.thresholds['combined'] !== undefined && this.thresholds['combined'] < minVal) {
        minVal = Number(this.thresholds['combined']);
      }
      // maxVal = maxVal + maxVal * 0.1;
      // minVal = minVal - minVal * 0.1;
      if (minVal < 0) {
        minVal = 0;
      }
      config.options.scales.y.max = maxVal;
      config.options.scales.y.min = minVal;
      if (this.thresholds['combined'] !== undefined) {
        config.plugins = [customPlugin];
      }
      if (this.combinedChart) this.combinedChart.destroy();
      var chart =  new this.$chart(ctx, config);

      const yScale = chart.scales.y;
      const ticks = yScale.getTicks();
      const min = yScale.min;
      const max = yScale.max;
      const stepSize = ticks.length > 1 ? ticks[1].value - ticks[0].value : 0;

      console.log('Y轴刻度:', ticks);
      console.log('最小值:', min);
      console.log('最大值:', max);
      console.log('步长:', stepSize);

      config.options.scales.y.max = maxVal + stepSize;
      config.options.scales.y.min = minVal - stepSize;

      if (config.options.scales.y.min < 0) {
        config.options.scales.y.min = 0;
      }
      if (config.options.scales.y.max <= 0) {
        config.options.scales.y.max = 10;
      }
      if (config.options.scales.y.max <= 1) {
        sclca = 3;
      }
      chart.destroy()
      chart =  new this.$chart(ctx, config);

      window.addEventListener("resize", () => {
        chart.resize();
      });
      return chart;
    },

    formatDecimal(value) {
      if (typeof value !== 'number') return value;
      return value % 1 !== 0 ? value.toFixed(2) : value.toString();
    },

    getRandomHexColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      do {
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
      } while (this.healthReportProp.colors.indexOf(color) !== -1)
      return color;
    },

    renderMetricsEcharts(container, data, title, unit, key) {
      let that = this;
      let name2ZH = [];
      let name2Unit = [];
      var customPlugin = {
        // 自定义插件：直接定义 afterDraw 钩子
        id: 'custom-annotation', // 可选：为插件命名
        afterDraw: (chart) => {
          const { options } = chart.config;
          const ctx = chart.canvas.getContext('2d');
          const yValue = options.plugins.customPlugin.value || 50;
          const yPixel = chart.scales.y.getPixelForValue(yValue);

          ctx.save();
          ctx.beginPath();
          ctx.setLineDash([5, 5]); // 设置虚线
          ctx.moveTo(0, yPixel);
          ctx.lineTo(chart.width, yPixel);
          ctx.strokeStyle = "grey";
          ctx.stroke();
          ctx.restore();
        }
      };
      const groups = data.reduce((acc, item) => {
        const key = item.gatherName || "";
        if (item.nameZH) {
          name2ZH[key] = item.nameZH;
        }
        if (item.unit) {
          name2Unit[key] = item.unit;
        }
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
      let timeList = [];
      let maxdataList = [];
      let mindataList = [];
      let avgdataList = [];

      Object.keys(groups).forEach(key => {
        console.log(`Group: ${key}`);
        let list = [];
        groups[key].forEach(item => {
          if (this.reportConfig.cycleType == "week") {
            list.push(item.cycleStart);
          } else {
            list.push(item.cycle);
          }
          if (!maxdataList[key]) {
            maxdataList[key] = [];
          }
          maxdataList[key].push({x: item.cycleStart || item.cycle, y: item.maxValue});

          if (!mindataList[key]) {
            mindataList[key] = [];
          }
          mindataList[key].push({x: item.cycleStart || item.cycle, y: item.minValue});
          if (!avgdataList[key]) {
            avgdataList[key] = [];
          }
          avgdataList[key].push({x: item.cycleStart || item.cycle, y: item.avgValue});
        });
        if (timeList.length < list.length) {
          timeList = list;
        }
      });
      let sclca = 2;
      let formatDecimal = function(value) {
        if (typeof value !== 'number') return value;
        return value % 1 !== 0 ? value.toFixed(sclca) : value.toString();
      };
      let config = {
        type: 'line',
        data: {
          labels: this.healthReportProp.deviceBasicInfo.last12Months, // 使用 UseRateLine 的时间轴
          datasets: []
        },
        options: {
          interaction: {
            intersect: false,
            mode: 'index',
          },
          plugins: {
            title: {
              display: true,
              text: title,
              font: {
                size: 20
              }
            },
            legend: {
              position: 'right', // 将图例位置设置为右侧
            },
            tooltip: {
              enabled: true,
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function(context) {
                  const datasetLabel = context.dataset.label || '';
                  const value = context.parsed.y; // 使用 parsed.y 获取Y值
                  return `${datasetLabel}: ${value}`; // 示例：添加百分比单位
                }
              }
            },
            customPlugin: {
              color: 'green', // 自定义参数
              value: this.thresholds[key] || 0
            }
          },
          scales: {
            y: {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                suggestedMin: 0,
                suggestedMax: 100,
                callback: function (value, index, values) {

                  return formatDecimal(value) + " " + unit;
                }
              }
            }
          }
        }
      };
      if (this.thresholds[key] !== undefined) {
        config.plugins = [customPlugin];
      }
      let allList = [];
      let datasets = [];

      timeList = this.healthReportProp.deviceBasicInfo.last12Months; // 获取x轴标签数组
      const maxLength = timeList.length;

      Object.keys(maxdataList).forEach(key => {
        timeList.forEach((item, index) => {
          for (let i = 0; i < maxdataList[key].length; i++) {
            if (maxdataList[key][i].x === item) {
              return;
            }
          }
          maxdataList[key].push({ x: item, y: null });
        });
        maxdataList[key].sort((a, b) => {
          return a.x.localeCompare(b.x);
        });
      });
      Object.keys(mindataList).forEach(key => {
        timeList.forEach((item, index) => {
          for (let i = 0; i < mindataList[key].length; i++) {
            if (mindataList[key][i].x === item) {
              return;
            }
          }
          mindataList[key].push({ x: item, y: null });
        });
        mindataList[key].sort((a, b) => {
          return a.x.localeCompare(b.x);
        });
      });
      Object.keys(avgdataList).forEach(key => {
        timeList.forEach((item, index) => {
          for (let i = 0; i < avgdataList[key].length; i++) {
            if (avgdataList[key][i].x === item) {
              return;
            }
          }
          avgdataList[key].push({ x: item, y: null });
        });
        avgdataList[key].sort((a, b) => {
          return a.x.localeCompare(b.x);
        });
      });

      Object.keys(maxdataList).forEach(key => {
        datasets.push({
          label: (name2ZH[key] ? name2ZH[key] : key) + " 最大值", // UseRateLine 的标签
          data: maxdataList[key],
          borderColor: this.getRandomHexColor(), // UseRateLine 的颜色
          fill: false
        });
        allList = allList.concat(maxdataList[key]);
      });
      Object.keys(mindataList).forEach(key => {
        datasets.push({
          label: (name2ZH[key] ? name2ZH[key] : key) + " 最小值", // UseRateLine 的标签
          data: mindataList[key],
          borderColor: this.getRandomHexColor(), // UseRateLine 的颜色
          fill: false
        });
        allList = allList.concat(mindataList[key]);
      });
      Object.keys(avgdataList).forEach(key => {
        datasets.push({
          label: (name2ZH[key] ? name2ZH[key] : key) + " 平均值", // UseRateLine 的标签
          data: avgdataList[key],
          borderColor: this.getRandomHexColor(), // UseRateLine 的颜色
          fill: false
        });
        allList = allList.concat(avgdataList[key]);
      });
      config.data.datasets = datasets;
      const allData = allList.map(item => item.y);
      if (allData.length == 0) {
        allData.push(0)
      }
      let maxVal = Math.ceil(Math.max(...allData));
      let minVal = Math.ceil(Math.min(...allData)) - 1;
      if (this.thresholds[key] !== undefined && this.thresholds[key] > maxVal) {
        maxVal = Number(this.thresholds[key]);
      }
      if (this.thresholds[key] !== undefined && this.thresholds[key] < minVal) {
        minVal = Number(this.thresholds[key]);
      }
      // maxVal = maxVal + maxVal * 0.1;
      // minVal = minVal - minVal * 0.1;
      if (minVal < 0) {
        minVal = 0;
      }
      config.options.scales.y.max = maxVal;
      config.options.scales.y.min = minVal;
      var ctx = container.getContext('2d');
      if (this.deviceMonitorChart[key]) this.deviceMonitorChart[key].destroy();
      var chart =  new this.$chart(ctx, config);
      const yScale = chart.scales.y;
      const ticks = yScale.getTicks();
      const min = yScale.min;
      const max = yScale.max;
      const stepSize = ticks.length > 1 ? ticks[1].value - ticks[0].value : 0;

      console.log('Y轴刻度:', ticks);
      console.log('最小值:', min);
      console.log('最大值:', max);
      console.log('步长:', stepSize);

      config.options.scales.y.max = maxVal + stepSize;
      config.options.scales.y.min = minVal - stepSize;

      if (config.options.scales.y.min < 0) {
        config.options.scales.y.min = 0;
      }
      if (config.options.scales.y.max <= 0) {
        config.options.scales.y.max = 10;
      }
      if (config.options.scales.y.max <= 1) {
        sclca = this.countDecimalPlaces(stepSize);
      }
      chart.destroy()
      chart =  new this.$chart(ctx, config);

      window.addEventListener("resize", () => {
        chart.resize();
      });
      return chart;
    },
    countDecimalPlaces(number) {
      const numberString = number.toString();
      const decimalPart = numberString.split('.')[1];
      return decimalPart ? decimalPart.length : 0;
    },

    InitCombinedLine(useRateData, loadingData) {
      this.$nextTick(() => {
        var container = this.$refs.CombinedLine; // 假设你在模板中添加了一个新的 canvas 元素
        this.combinedChart = this.renderCombinedEcharts(container, useRateData, loadingData);
      });
    },

    InitMonitormMetricsLine() {
      for (let key in this.deviceMonitor) {
        var container = this.$refs[key][0]; // 假设你在模板中添加了一个新的 canvas 元素
        this.deviceMonitorChart[key] = this.renderMetricsEcharts(container, this.deviceMonitor[key], this.monitormMetrics[key], this.monitorUtil[key], key);
      }
    },

    img2Base64(imgElement) {
      return new Promise((resolve, reject) => {
        // 创建一个新的 Image 对象
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 如果需要跨域图片，设置跨域属性
        img.src = imgElement.src;
        // 等待图片加载完成
        img.onload = function () {
          // 创建一个 canvas 元素
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // 设置 canvas 的宽高与图片一致
          canvas.width = img.width;
          canvas.height = img.height;

          // 将图片绘制到 canvas 上
          ctx.drawImage(img, 0, 0);

          // 将 canvas 转换为 Base64 图片
          const base64 = canvas.toDataURL('image/png'); // 可以指定格式，如 'image/jpeg'

          console.log(base64); // 输出 Base64 编码的图片
          resolve(base64);
        }
        img.onerror = function () {
          reject();
        };
      });
    },
    exportToWord: async function () {
      // 确保图表已经渲染
      await this.$nextTick();

      const combinedLineContainer = this.$refs.CombinedLine;

      const logo = this.$refs.logo;
      const coverImage = this.$refs.coverImage;
      const logoBase64 = await this.img2Base64(logo);
      const coverImageBase64 = await this.img2Base64(coverImage);
      const inputnotes = this.$refs.inputnotes;

      const newLogo = document.createElement('img');
      newLogo.src = logoBase64;
      newLogo.width = logo.width;
      newLogo.height = logo.height;

      const newCoverImage = document.createElement('img');
      newCoverImage.src = coverImageBase64;
      newCoverImage.width = '100%';
      newCoverImage.height = 'auto';

      logo.parentNode.replaceChild(newLogo, logo);
      coverImage.parentNode.replaceChild(newCoverImage, coverImage);

      const combinedLineImage = await html2canvas(combinedLineContainer, {backgroundColor: '#ffffff'});

      const combinedLineBase64 = combinedLineImage.toDataURL('image/png');

      const newcombinedLineImage = document.createElement('img');
      newcombinedLineImage.src = combinedLineBase64;
      newcombinedLineImage.style.width = '100%';
      newcombinedLineImage.style.height = 'auto';

      combinedLineContainer.parentNode.replaceChild(newcombinedLineImage, combinedLineContainer);
      let images = await this.monitorMetricsChartExport();

      // 移除导出按钮
      const exportButton = this.$refs.exportButton.$el;
      if (exportButton) {
        exportButton.remove();
      }

      this.$refs.charttable.style.width = 'auto';

      const notes = document.createElement('p');
      notes.innerHTML = this.notes;

      inputnotes.parentNode.replaceChild(notes, inputnotes);

      const thresholdInputs = Array.from(this.$el.querySelectorAll('.chart-graph input[type="number"]'));
      const inputValues = thresholdInputs.map(input => input.value);
      const inputParents = [];

      // 替换为文本显示
      thresholdInputs.forEach(input => {
        const span = document.createElement('span');
        span.textContent = input.value;
        inputParents.push(input.parentNode);
        input.parentNode.replaceChild(span, input);

      });

      this.isExport = true;
      await this.$nextTick();

      // 获取报告内容
      const reportContent = document.querySelector('.report-container').innerHTML;

      console.info(reportContent);

      // 获取样式
      const collectAllStyles = () => {
        const styleSheets = Array.from(document.styleSheets);
        const styles = [];

        styleSheets.forEach(sheet => {
          try {
            Array.from(sheet.cssRules).forEach(rule => {
              styles.push(rule.cssText);
            });
          } catch (e) {
            // 跨域样式表忽略
          }
        });

        return styles.join('\n');
      };
      const allStyles = collectAllStyles();

      // 将报告内容转换为 Word 文档
      console.info("reportContent");
      console.log(reportContent)

      let html = `
                  <!DOCTYPE html>
                  <html>
                  <head>
                   <meta charset="utf-8"/>
                  <style>
                  ${allStyles}
                  </style>
                  </head>
                  <body>
                  ${reportContent}
                  </body>
                  </html>
                `;
      console.info(html);

      this.downloadFile(`/api/upload/htmltoword`, html);

      newcombinedLineImage.parentNode.replaceChild(combinedLineContainer, newcombinedLineImage);
      for (let key in images) {
        images[key].newImage.parentNode.replaceChild(images[key].container, images[key].newImage);
      }

      this.$refs.charttable.style.width = '100%';

      notes.parentNode.replaceChild(inputnotes, notes);
      // 导出完成后恢复输入框
      inputParents.forEach((parent, index) => {
        const span = parent.querySelector('span');
        if (span) {
          let input = thresholdInputs[index];
          input.value = inputValues[index];
          span.parentNode.replaceChild(input, span);
        }
      });


      newLogo.parentNode.replaceChild(logo, newLogo);
      newCoverImage.parentNode.replaceChild(coverImage, newCoverImage);

      // 重新添加导出按钮
      if (exportButton) {
        document.querySelector('.export-button').appendChild(exportButton);
      }
    },

    async monitorMetricsChartExport() {
      let monitorMetricsData = this.deviceMonitor;
      let images = {};
      for (let key in monitorMetricsData) {
        let container = this.$refs[key][0];
        const image = await html2canvas(container, {backgroundColor: '#ffffff'});
        const base64 = image.toDataURL('image/png');
        const newImage = document.createElement('img');
        newImage.src = base64;
        newImage.style.width = '100%';
        newImage.style.height = 'auto';
        container.parentNode.replaceChild(newImage, container);
        images[key] = {newImage, container};
      }
      return images;
    },

    downloadFile(fileUrl, html) {
      axios.post(fileUrl, {html: html}, {responseType: 'blob'})
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "health_report.docx");
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.error(error);
          });
    }
  }
}
</script>

<style scoped>
/* styles.css */
.report-container {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.logo {
  width: 200px;
  background-color: white; /* 设置 logo 背景为白色 */
}

.report-title {
  text-align: center;
}

.report-title h1 {
  margin: 0;
}

.report-title p {
  margin: 0;
  color: #666;
}

.info-section {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.info-section2 {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.info-item {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
}
.fontinfo {
  font-size: 14px;
}
.info-item span {
  font-weight: bold;
}

.chart-section {
  margin-top: 20px;
}

.chart-table {
  border: 1px solid #000; /* 添加边框 */
  margin-top: 20px;
  background-color: #f5f5f5; /* 设置背景色为灰色 */
  width: 100%; /* 确保表格宽度与其他内容对齐 */
  border-collapse: collapse; /* 合并边框 */
  font-size: 13px;
}

.chart-table th,
.chart-table td {
  border: 1px solid #000; /* 添加边框 */
  padding: 8px;
  text-align: left;
  font-size: 13px;
}

.chart-table thead tr:first-child th,
.chart-table thead tr:nth-child(2) th {
  border: none; /* 隐藏特定单元格的边框 */
}

.chart-graph {
  position: relative;
  width: 100%; /* 确保图表宽度与其他内容对齐 */
  margin-top: 20px;
  padding-top: 20px;
}

#chart {
  width: 100%;
  height: 300px;
}

div.info-section p {
  color: red;
}

div.info-section2 p {
  color: red;
}

.export-button {
  margin-top: 100px;
  text-align: center;
}

.top-3-trip {
  border: 1px solid #000; /* 添加边框 */
  margin-top: 20px;
  background-color: #f5f5f5; /* 设置背景色为灰色 */
  width: 100%; /* 确保表格宽度与其他内容对齐 */
  border-collapse: collapse; /* 合并边框 */
}

.top-3-trip th,
.top-3-trip td {
  border: 1px solid #000; /* 添加边框 */
  padding: 8px;
  text-align: left;
  vertical-align: middle; /* 垂直居中对齐 */
  font-size: 13px;
}

.report-title {
  text-align: left;
  padding-left: 20px;
  border-left: 5px solid #ff4500; /* 橙色边框 */
}

.report-title h1 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.report-title p {
  margin: 0;
  color: #666;
  font-size: 16px;
}

.cover-image {
  width: 100%;
  margin-bottom: 20px;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  background-color: #FF3399;
  color: white;
  text-align: center;
}

.health-definition {
  margin-top: 20px;
}

.health-definition h3 {
  margin: 10px 0;
}

.health-definition p {
  margin: 5px 0;
}

.notes {
  margin-top: 20px;
  font-style: italic;
}

.header-load-rate {
  background-color: #990033;
  color: white;
  text-align: center;
}

.load-rate-definition {
  margin-top: 20px;
}

.load-rate-definition p {
  margin: 5px 0;
}

.editor-section {
  margin-top: 40px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.editor-section h2 {
  margin-bottom: 10px;
}

.editor-section textarea {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical; /* 允许垂直调整大小 */
}

.footer {
  margin-top: 50px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center;
 text-align:left;
}

.health-definition.footer {
  margin-top: 10px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center;
}

.load-rate-definition.footer {
  margin-top: 10px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center; /* 居中对齐 */
}

.load-rate-definition.footer h3 {
  margin: 10px 0;
}

.load-rate-definition.footer p {
  margin: 5px 0;
}

.info-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px; /* 保持原有间隙 */
  margin: 20px 0 40px 0;
  color: red;
}

.info-table td.info-item {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  width: calc(100% / 3 - 13px); /* 保持三列等宽 */
  vertical-align: top;
  margin-bottom: 30px;
}

.info-table span {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

.info-table p {
  margin: 0;
  color: #666;
}

.info-section, .info-section2 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px;
  margin: 20px 0;
}

.info-section td, .info-section2 td {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  vertical-align: top;
}

.info-section span, .info-section2 span {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

.info-section p, .info-section2 p {
  margin: 0;
  color: #666;
}

.chart-graph {
  align-items: flex-start;
  margin-bottom: 20px;
}

.chart-graph canvas {
  flex: 1;
  min-width: 0; /* 防止图表被压缩 */
  margin-right: 20px;
}

.chart-graph .threshold-input {
  float: right;
  text-align: right;
  margin-top: -20px;
}

.threshold-input input {
  width: 50px;
  display: inline-block;
  vertical-align: middle;
}

/* 针对第一个combined图表的特殊处理 */
#combinedChart-container {
  display: flex;
  align-items: flex-start;
}

#combinedChart {
  flex: 1;
  margin-right: 20px;
}

.combined-threshold {
  float: right;
  text-align: right;
  margin-top: -20px;

}

.combined-threshold input {
  width: 50px;
  display: inline-block;
  vertical-align: middle;
}


/* 针对列数不同的表格 */
.info-section { /* 默认3列 */
  table-layout: fixed;
}
.info-section tr td {
  width: calc(100% / 3);
}

.info-section2 { /* 4列 */
  table-layout: fixed;
}
.info-section2 tr td {
  width: 25%;
}

.product-detail {
  border: 1px solid #ddd;
  padding: 8px;
  margin-bottom: 5px;
}

.product-detail div {
  margin-bottom: 4px;
}

/* 新增的 custom-table 样式 */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
}

.custom-table thead tr:first-child th {
  background-color:  #f5f5f5;
}

/* 确保与 chart-table 样式一致 */
.sfa-table {
  border: 1px solid #000;
  margin-top: 20px;
  background-color: #f5f5f5;
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.sfa-table th,
.sfa-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: left;
  font-size: 13px;
}

/* 父容器样式 */
.product-container {
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}

/* 每个产品项的间距 */
.product-item {
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

/* 嵌套表格样式 */
.product-detail {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.product-detail th {
  background-color: #f5f5f5;
  padding: 6px;
  text-align: right;
  width: 30%; /* 固定属性名宽度 */
}

.product-detail td {
  padding: 6px;
  border-top: 1px solid #e0e0e0;
}

.product-detail tr:last-child td {
  border-bottom: 1px solid #e0e0e0;
}

/* 悬停效果 */
.product-detail:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

</style>

